import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { all, isEmpty, isNil, values, without } from 'ramda';
import { EngageConstants } from '../../engage/engage.constants';
import { Router } from '@angular/router';

@Component({
  selector: 'stat-card',
  templateUrl: './stat-card.component.html',
  styleUrls: ['./stat-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class StatCardComponent {
  @Input() public tile: any = {};
  @Input() public isMobile: boolean = false;
  @Output() public buttonClicked = new EventEmitter();

  public checkAverageHelpText = EngageConstants.checkAverageHelpText;
  public salesAttachedHelpText = EngageConstants.salesAttachedHelpText;
  public redemptionRateAtMyLocationHelpText = EngageConstants.redemptionRateAtMyLocationHelpText;

  constructor(private readonly router: Router) {}

  public onClicked() {
    if (this.tile.externalLink) {
      window.open(this.tile.externalLink);
    } else if (this.hasData(this.tile.data) && !this.tile.drillDownDisabled) {
      this.buttonClicked.emit(this.tile);
    }
  }

  public onViewCampaignDetailsClicked(campaign) {
    if (campaign.campaignId) {
      this.router.navigate(['/engage/campaign-details'],
        { queryParams: { id: campaign.campaignId, redirectTo: 'engageAnalyticsTab' } });
    } else {
      this.router.navigate(['/engage/engage-details'],
        { queryParams: { type: 'offer', mode: 'review', id: campaign.batchId, redirectedTo: 'engageAnalyticsTab' } });
    }
  }

  // If there is an array in the object and it is empty, show no data
  public hasData(data) {
    if (!data || isEmpty(data) || (data.checkZeroCountData !== undefined && !data.checkZeroCountData)) {
      return false;
    }
    const dataValues = values(data);
    if (without([null], dataValues).length > 0) {
      const isNotData = (dataPiece) => {
        return isEmpty(dataPiece) || isNil(dataPiece) || dataPiece === 0 || dataPiece === 0.0 || dataPiece === '0.0';
      };
      return !all(isNotData)(dataValues);
    }
  }

  public getPageTitle() {
    let title = this.tile.marketGiveawayTile ? this.tile.id : this.tile.title;
    return `Understand Tile: ${title}`;
  }
}
